import React from 'react';
import { SimplePage } from '../components/shared/SharedComponents';
import {
  LegalPageContent,
  LegalLastUpdated,
  LegalSection,
  LegalSectionTitle,
  LegalParagraph,
  LegalSubsectionTitle,
  renderLegalContent,
} from '../components/legal/legalPagePrimitives';
import { useContent } from '../hooks/useContent';

function Disclaimer() {
  const { disclaimer } = useContent();

  const title = disclaimer?.title || 'Disclaimer';
  const description = disclaimer?.description || '';
  const lastUpdated = disclaimer?.lastUpdated;
  const lastUpdatedLabel = disclaimer?.lastUpdatedLabel || 'Last updated:';
  const emptySectionMessage = disclaimer?.emptySectionMessage || 'Detailed information for this section will be published here soon.';
  const emptyContentMessage = disclaimer?.emptyContentMessage || 'Detailed information will be published here soon.';
  const sections = Array.isArray(disclaimer?.sections) ? disclaimer.sections : [];

  return (
    <SimplePage title={title} description={description}>
      <LegalPageContent>
        {lastUpdated && <LegalLastUpdated>{lastUpdatedLabel} {lastUpdated}</LegalLastUpdated>}

        {sections.length > 0 ? (
          sections.map((section, sectionIndex) => (
            <LegalSection key={`${section?.title || 'section'}-${sectionIndex}`} $compact>
              {section?.title && <LegalSectionTitle>{section.title}</LegalSectionTitle>}

              {Array.isArray(section?.paragraphs) && section.paragraphs.length > 0 ? (
                section.paragraphs.map((paragraph, paragraphIndex) => {
                  // Check if paragraph is an object with text and subsections
                  if (typeof paragraph === 'object' && paragraph !== null && paragraph.text) {
                    return (
                      <div key={`para-${paragraphIndex}`}>
                        <LegalParagraph>{paragraph.text}</LegalParagraph>
                        {Array.isArray(paragraph.subsections) && paragraph.subsections.length > 0 && (
                          <div>
                            {paragraph.subsections.map((subsection, subsectionIndex) => {
                              const isEmptyTitle = !subsection?.title || subsection.title === '';
                              return (
                                <div key={`sub-${subsectionIndex}`} style={{ marginTop: isEmptyTitle ? '16px' : '28px' }}>
                                  {subsection?.title && <LegalSubsectionTitle>{subsection.title}</LegalSubsectionTitle>}
                                  {renderLegalContent(subsection?.paragraphs, isEmptyTitle)}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  }
                  // Regular string paragraph
                  if (typeof paragraph === 'string') {
                    return <LegalParagraph key={`para-${paragraphIndex}`}>{paragraph}</LegalParagraph>;
                  }
                  return null;
                })
              ) : (
                <LegalParagraph>
                  {emptySectionMessage}
                </LegalParagraph>
              )}

              {/* Legacy support: section-level subsections (for backward compatibility) */}
              {Array.isArray(section?.subsections) && section.subsections.length > 0 && (
                <div>
                  {section.subsections.map((subsection, subsectionIndex) => {
                    const isEmptyTitle = !subsection?.title || subsection.title === '';
                    return (
                      <div key={`legacy-sub-${subsectionIndex}`} style={{ marginTop: isEmptyTitle ? '16px' : '28px' }}>
                        {subsection?.title && <LegalSubsectionTitle>{subsection.title}</LegalSubsectionTitle>}
                        {renderLegalContent(subsection?.paragraphs, isEmptyTitle)}
                      </div>
                    );
                  })}
                </div>
              )}

              {(!Array.isArray(section?.paragraphs) || section.paragraphs.length === 0) &&
                (!Array.isArray(section?.subsections) || section.subsections.length === 0) ? (
                <LegalParagraph>
                  {emptySectionMessage}
                </LegalParagraph>
              ) : null}
            </LegalSection>
          ))
        ) : (
          <LegalParagraph>
            {emptyContentMessage}
          </LegalParagraph>
        )}
      </LegalPageContent>
    </SimplePage>
  );
}

export default Disclaimer;

